import { HeatmapWidgetEntity } from 'src/pages/dashboard/features/heatmap-widget/HeatmapWidget.entity';
import { parseHeatmapWidgetInternalState } from 'src/pages/dashboard/features/heatmap-widget/parseHeatmapWidget';

import type { TSerializedWidget } from 'src/entities/workspace/types';

export function mapHeatmapWidget(widget: TSerializedWidget, index: number): HeatmapWidgetEntity {
  const internalState = parseHeatmapWidgetInternalState(widget.internalState ?? {});

  const heatmapWidget = new HeatmapWidgetEntity(
    {
      wellId: internalState.wellId,
      stateParams: internalState.stateParams,
      type: 'heatmap-widget',
    },
    {
      uuid: widget.uuid,
      isPinned: !!widget.isPinned,
      zIndex: index + 1,
      isFullscreen: widget.isFullscreen ?? false,
      position: {
        x: widget?.position?.x ?? 0,
        y: widget?.position?.y ?? 0,
      },
      size: {
        w: widget.size?.w ?? 80,
        h: widget.size?.h ?? 80,
      },
      groupId: widget.groupId,
      isGroupsDefaultOpened: false,
    }
  );

  return heatmapWidget;
}
